__webpack_require__.p = "/countries-quiz/";